module.exports = __webpack_public_path__ + "static/media/raindrop.e364bbaa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/game/bomber/drops/raindrop.svg
// module id = 34
// module chunks = 0